import React from "react";
import { Popover } from "antd";
import {
  AudioMutedOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { ImPhoneHangUp } from "react-icons/im";
import { AiFillAudio } from "react-icons/ai";
import { BiDialpadAlt } from "react-icons/bi";
import { useAppDispatch } from "../../../redux/utils/Dispatcher";
import {
  hangup,
  holdCall,
  muteCall,
  resumeCall,
  sendDTMF,
  unmuteCall,
} from "../../../redux/slices/sipSlice";
import { RootState } from "../../../redux/store";
import Dialer from "../../common/Dialer";
import SpeakerSelector from "../SpeakerSwitcher";
import "./index.scss";

const HangupIcon = ImPhoneHangUp as unknown as React.FC;
const MuteIconFilled = AiFillAudio as unknown as React.FC;
const DialpadIcon = BiDialpadAlt as unknown as React.FC;

interface CallControlsProps {
  currentCall: {
    id: string;
    number?: string;
    info?: string;
    status: string;
    isMuted?: boolean;
    isOnHold?: boolean;
    startTime?: number;
  };
  isMini?: boolean;
  showDTMF?: boolean;
}

const CallControls: React.FC<CallControlsProps> = ({
  currentCall,
  isMini = false,
  showDTMF = true,
}) => {
  const dispatch = useAppDispatch();
  const { calls, currentCallId } = useSelector((state: RootState) => state.sip);

  const handleSendDtmf = (key: string) => {
    if (calls[currentCall.id].id !== currentCallId) return;
    dispatch(sendDTMF({ callId: currentCall.id, tone: key }));
  };

  return (
    <div className="call-controls" onClick={(e) => e.stopPropagation()}>
      <SpeakerSelector />

      <div
        className="call-button"
        onClick={() => {
          if (currentCall?.isOnHold) {
            if (calls[currentCall.id].id !== currentCallId) return;
            dispatch(resumeCall(currentCall.id));
          } else {
            dispatch(holdCall(currentCall.id));
          }
        }}
      >
        {currentCall?.isOnHold ? (
          <PlayCircleOutlined />
        ) : (
          <PauseCircleOutlined />
        )}
      </div>

      {showDTMF && (
        <Popover
          content={<Dialer showInput={true} onKeyClick={handleSendDtmf} />}
          trigger="click"
        >
          <div className="call-button">
            <DialpadIcon />
          </div>
        </Popover>
      )}

      <div
        className="call-button"
        onClick={() => {
          if (calls[currentCall.id].id !== currentCallId) return;

          if (currentCall?.isMuted) {
            dispatch(unmuteCall(currentCall.id));
          } else {
            dispatch(muteCall(currentCall.id));
          }
        }}
      >
        {currentCall?.isMuted ? <AudioMutedOutlined /> : <MuteIconFilled />}
      </div>

      {!isMini && (
        <div
          onClick={() => dispatch(hangup(currentCall.id))}
          className="call-button end-call"
        >
          <HangupIcon />
        </div>
      )}
    </div>
  );
};

export default CallControls;
